/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RestaurantSearchResult,
    RestaurantSearchResultFromJSON,
    RestaurantSearchResultFromJSONTyped,
    RestaurantSearchResultToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetOrderAgainRestaurantsResponse
 */
export interface GetOrderAgainRestaurantsResponse {
    /**
     * 
     * @type {Array<RestaurantSearchResult>}
     * @memberof GetOrderAgainRestaurantsResponse
     */
    restaurants: Array<RestaurantSearchResult>;
}

export function GetOrderAgainRestaurantsResponseFromJSON(json: any): GetOrderAgainRestaurantsResponse {
    return GetOrderAgainRestaurantsResponseFromJSONTyped(json, false);
}

export function GetOrderAgainRestaurantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderAgainRestaurantsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restaurants': ((json['restaurants'] as Array<any>).map(RestaurantSearchResultFromJSON)),
    };
}

export function GetOrderAgainRestaurantsResponseToJSON(value?: GetOrderAgainRestaurantsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restaurants': ((value.restaurants as Array<any>).map(RestaurantSearchResultToJSON)),
    };
}


